module.exports = __webpack_public_path__ + "img/icons BFr_1.b93ea947.svg";